import { CodeByStatusName } from '@types';

export const THEME = {
  token: {
    // Should be the same as in styles/variables.scss
    colorPrimary: '#3452f8',
  },
  components: {
    Form: {
      itemMarginBottom: 0,
    },
  },
};

// Active when the `redesign` feature flag is enabled. Token values mirror
// styles/_tokens.redesign.scss so Ant Design and CSS stay in lockstep.
export const THEME_REDESIGN = {
  token: {
    colorPrimary: '#3452f8',
    colorSuccess: '#3bd895',
    colorWarning: '#f8d135',
    colorError: '#fe4955',
    colorInfo: '#3452f8',
    colorTextBase: '#1a1a1a',
    colorBgBase: '#ffffff',
    borderRadius: 6,
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    fontSize: 16,
  },
  components: {
    Form: {
      itemMarginBottom: 0,
    },
    Button: {
      borderRadius: 6,
      controlHeight: 40,
      fontWeight: 600,
    },
    Card: {
      borderRadiusLG: 8,
    },
    Input: {
      borderRadius: 4,
      controlHeight: 40,
    },
  },
};

// Colors should match status colors styles/variables.scss
export const COLOR_BY_STATUS_CODE: {
  [statusCode: string]: string;
} = {
  [CodeByStatusName.success]: '#45d470',
  [CodeByStatusName.failed]: '#fe4955',
  [CodeByStatusName.retrying]: '#49fef2',
  [CodeByStatusName.in_progress]: '#f8d135',
  [CodeByStatusName.in_queue]: '#bbb',
  [CodeByStatusName.skipped]: '#bbb',
  [CodeByStatusName.timeout]: '#ff8c00', // orange color for timeout
};
